import axios from 'axios';

const HYDRA_AUTH_URL = 'https://auth.acespireconsulting.com';
const REDIRECT_URI = 'https://scriptix.acespireconsulting.com/callback';

// ── Auth headers — token read fresh on every call ──
export const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// ── Decode role from Hydra id_token ──
export const getUserRoleFromToken = () => {
  try {
    // Hydra flow (production) — id_token takes priority
    const idToken = localStorage.getItem('id_token');
    if (idToken) {
      const payload = idToken.split('.')[1];
      const decoded = JSON.parse(atob(payload));
      return decoded.type || decoded.role || null;
    }

    // Pre-Hydra flow (local dev) — fallback to authToken
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      const payload = authToken.split('.')[1];
      const decoded = JSON.parse(atob(payload));
      return decoded.type || decoded.role || null;
    }

    return null;
  } catch {
    return null;
  }
};

// ── Step 1: Redirect browser to Hydra ──
export const getLoginChallenge = () => {
  console.log('=== getLoginChallenge called ===');
  console.log('HYDRA_AUTH_URL:', HYDRA_AUTH_URL);
  console.log('REDIRECT_URI:', REDIRECT_URI);

  const params = new URLSearchParams({
    client_id: 'frontend-client',
    response_type: 'code',
    scope: 'openid profile email',
    redirect_uri: REDIRECT_URI,
    state: Math.random().toString(36).substring(2) + Date.now().toString(36)
  });
  const url = `${HYDRA_AUTH_URL}/oauth2/auth?${params.toString()}`;
  console.log('Full URL:', url);
  window.location.href = `${HYDRA_AUTH_URL}/oauth2/auth?${params.toString()}`;
};

// ── Step 2: Submit credentials to your API ──
export const loginWithHydra = async (email, password, login_challenge) => {
  try {
    const response = await axios.post(
      'https://dpp-api.acespireconsulting.com/login-admin',
      { email, password, login_challenge }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.error || 'Login failed');
    }
    throw new Error('No response from server');
  }
};

// ── Step 4: Exchange code for tokens ──
export const exchangeCodeForToken = async (code) => {
  try {
    const params = new URLSearchParams({
      grant_type: 'authorization_code',
      code: code,
      redirect_uri: REDIRECT_URI
    });
    const response = await axios.post(
      `${HYDRA_AUTH_URL}/oauth2/token`,
      params.toString(),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic ' + btoa('frontend-client:kg2ln3Ina8gw8P4Q')
        }
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.error_description || 'Token exchange failed');
    }
    throw new Error('No response from server');
  }
};